/**
 * Full-screen loading overlay.
 *
 * Uses `position: fixed` so it is always centred in the VIEWPORT — the old
 * loader was `position: absolute` against the document, so on a scrolled page
 * it sat off-screen at the top. The backdrop also blocks clicks while a save
 * is in flight.
 */
const KEYFRAMES = `
@keyframes capex-loader-spin { to { transform: rotate(360deg); } }
@keyframes capex-loader-pulse { 0%, 100% { opacity: .35; } 50% { opacity: 1; } }
`;

export default function Loader({ message = "Please wait…" }) {
    return (
        <div
            role="progressbar"
            aria-busy="true"
            aria-label={message}
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 2000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(15, 23, 42, 0.35)",
                backdropFilter: "blur(2px)",
                WebkitBackdropFilter: "blur(2px)",
            }}
        >
            <style>{KEYFRAMES}</style>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 14,
                    padding: "26px 34px",
                    borderRadius: 16,
                    background: "#fff",
                    boxShadow: "0 12px 40px rgba(0,0,0,0.18)",
                    minWidth: 180,
                }}
            >
                <div style={{ position: "relative", width: 54, height: 54 }}>
                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            borderRadius: "50%",
                            border: "5px solid #e3ecfb",
                        }}
                    />
                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            borderRadius: "50%",
                            border: "5px solid transparent",
                            borderTopColor: "#1A73E8",
                            borderRightColor: "#1A73E8",
                            animation: "capex-loader-spin .8s linear infinite",
                        }}
                    />
                </div>
                <div
                    style={{
                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                        fontSize: 14,
                        fontWeight: 500,
                        color: "#344767",
                        animation: "capex-loader-pulse 1.6s ease-in-out infinite",
                    }}
                >
                    {message}
                </div>
            </div>
        </div>
    );
}
